import React, { Fragment } from 'react'
import {
  Input, InputGroup, CustomInput, InputGroupText, InputGroupAddon,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Row, Col,
  FormGroup, Button,
  Progress, Spinner
} from 'reactstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import classnames from 'classnames'
import LinearProgress from '@material-ui/core/LinearProgress';
import { connect } from 'react-redux'
import { ReactSortable } from 'react-sortablejs'
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { Menu, Item, MenuProvider } from 'react-contexify'
import { VscDebugStart, VscDebugStop } from 'react-icons/vsc'
import * as Icon from 'react-feather'
import Checkbox from "../../../components/@vuexy/checkbox/CheckboxesVuexy"

// Pixacom imports
import { startWork, endWork } from "../../../redux/actions/activity/activityActions"
import { getTasks, loading, sorting, updateTasks/*, untrash*/ } from '../../../redux/actions/todo/index'
import Avatar from '../../../components/DSA/Avatar'
import moment from 'moment-timezone'
import '../../../assets/scss/pages/app-todo.scss';

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

var isEqual = function (value, other) {

	// Get the value type
	var type = Object.prototype.toString.call(value);

	// If the two objects are not the same type, return false
	if (type !== Object.prototype.toString.call(other)) return false;

	// If items are not an object or array, return false
	if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

	// Compare the length of the length of the two items
	var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
	var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
	if (valueLen !== otherLen) return false;

	// Compare two items
	var compare = function (item1, item2) {

		// Get the object type
		var itemType = Object.prototype.toString.call(item1);

		// If an object or array, compare recursively
		if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
			if (!isEqual(item1, item2)) return false;
		}

		// Otherwise, do a simple comparison
		else {

			// If the two items are not the same type, return false
			if (itemType !== Object.prototype.toString.call(item2)) return false;

			// Else if it's a function, convert to a string and compare
			// Otherwise, just compare
			if (itemType === '[object Function]') {
				if (item1.toString() !== item2.toString()) return false;
			} else {
				if (item1 !== item2) return false;
			}

		}
	};

	// Compare properties
	if (type === '[object Array]') {
		for (var i = 0; i < valueLen; i++) {
			if (compare(value[i], other[i]) === false) return false;
		}
	} else {
		for (var key in value) {
			if (value.hasOwnProperty(key)) {
				if (compare(value[key], other[key]) === false) return false;
			}
		}
	}

	// If nothing failed, return true
	return true;

};

class Tasks extends React.Component {

    state = {
        tasks: this.props.tasks,
        tasksFiltered: this.props.tasks,
        modalComplete: false,
        modalCompletePending: false,
        messageComplete: '',
        setTimeComplete: false,
        timeComplete: null,
        itemToComplete: null,
        filter: this.props.filter
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.tasks !== this.props.tasks || !isEqual(this.state.tasks, this.props.tasks))) this.setState({ tasks: this.props.tasks });
        if ((prevProps.tasksFiltered !== this.props.tasksFiltered || !isEqual(this.state.tasksFiltered, this.props.tasksFiltered)) && this.props.tasksFiltered !== null && this.props.tasksFiltered !== undefined) this.setState({ tasksFiltered: this.props.tasksFiltered });
        if (prevProps.filter !== this.props.filter) this.setState({ filter: this.props.filter });
    }

    // Handlers
    handleFilter = (e) => {
        //filter
    }
    handleSort = (e, sort) => {
        e.preventDefault();
        this.props.sorting(sort);
        this.setState({ tasksFiltered: this.props.store.filteredTasks })
    }

    updateSearchData = data => {
        this.setState({ tasksFiltered: data });
    }

    // Renders
    renderTags = arr => {
        // render tags and bases
    }
    renderAvatar = obj => {
        /*const item = obj.assignee

        if (item.avatar === undefined || item.avatar === null) {
            return <Avatar img={blankAvatar} imgHeight='32' imgWidth='32' />
        } else if (item.avatar !== '') {
            return <Avatar img={item.avatar} imgHeight='32' imgWidth='32' />
        } else {
            return <Avatar color={resolveAvatarVariant(obj.tags)} content={item.fullName} initials />
        }*/

        //return <Avatar color='success' content='tester tester' />;

        return (
            <div className={classnames('avatar-group')} >
                {obj.map(solver => {
                    return (
                        <Avatar className='pull-up' color={solver.user ? solver.user.avatarColor : "primary"} content={solver.surName + " " + solver.firstName} />
                    )
                })}
            </div>
        )
    }
    render() {
        const { tasks, tasksFiltered, query } = this.state;
        const { loading } = this.props.store;

        const LinearIndeterminate = () => {
            const classes = makeStyles(theme => ({
                root: {
                    width: '100%',
                    '& > * + *': {
                        marginTop: theme.spacing(2),
                    },
                },
            }));
          
            return (
                <div className={classes.root}>
                    <LinearProgress />
                    <div className="p-1 loading-info">Loading ...</div>
                </div>
            );
        };

        const renderTask = (item, className = "") => {
            let logedUser = this.props.user;
            let solver = item.solvers.find(solver => solver.id === logedUser.personID) !== undefined;
            
            

            return (
                <React.Fragment>
                    
                    <li
                        key={item.task.id}
                        className={classnames(className, {
                            active: item.active,
                            completed: item.isCompleted
                        })}
                    >
                        
                        <div className='todo-modal-list-wrapper'>
                            
                                <div className='todo-modal-area'>
                                    {item.active && <VscDebugStart /> }
                                    {/*<CustomInput
                                        type='checkbox'
                                        className='custom-control-Primary'
                                        id={item.title}
                                        label=''
                                        //onChange={e => dispatch(updateTask({ ...item, isCompleted: e.target.checked }))}
                                        checked={item.task.completed}
                                    />*/}
                                    {this.renderAvatar(item.solvers)}
                                    <small className='text-nowrap text-center text-muted ml-1 mr-1' style={{width: "30px"}}>
                                    {item.task.end ? (new Date(item.task.end).toLocaleString('default', { month: 'short' }) + ' ' + new Date(item.task.end).getDate().toString().padStart(2, '0')) : '-' }
                                    </small>
                                    {item.task.workTime < item.task.remainingTime &&
                                    <Progress 
                                        value={item.task.workTime} 
                                        color={item.task.workTime / item.task.remainingTime >= 1 ? "success" : (item.task.workTime / item.task.remainingTime > 0.5 ? "warning" : "danger" )}
                                        max={item.task.remainingTime}
                                    ></Progress>}
                                    {item.task.workTime > item.task.remainingTime &&
                                    <Progress multi>
                                        <Progress bar color="warning" value={item.task.remainingTime} max={item.task.workTime} ></Progress>
                                        <Progress bar color="danger" value={item.task.workTime - item.task.remainingTime} max={item.task.workTime}></Progress>
                                    </Progress>}
                                    <span className='todo-title'>{item.task.subject}</span>
                                </div>

                                <div className='todo-item-action mt-lg-0 mt-50'>
                                    {
                                        solver && !item.active && !item.task.trashed && this.props.activity.lastActivity.activityType !== 3 &&
                                        <Button.Ripple
                                            color='success'
                                            onClick={ async () => { this.props.toggleModal(); this.props.toggleModalParrent();; await this.props.startWork(item.task.id, this.props.activity.lastActivity); this.props.updateTasks(item.task.id, 'update'); } }
                                        >
                                            Začít práci
                                        </Button.Ripple>
                                    }
                                    
                                    {
                                        solver && item.active && !item.task.trashed &&
                                        <Button.Ripple
                                            color='primary'
                                            onClick={ async () => { await this.toggleModalComplete(item.task); } }
                                        >
                                            Ukončit práci
                                        </Button.Ripple>
                                    }
                                    
                                    {/*item.tags.length ? <div className='badge-wrapper mr-1'>{/* renderování tagů /}</div> : null*/}
                                </div>

                            
                        </div>
                    </li>
                </React.Fragment>)
          }

        const renderTasks = () => {
            var tasksToRender = tasksFiltered.filter((item) => { 
                let solver = item.solvers.find(solver => solver.id === this.props.user.personID) !== undefined;

                return !item.task.trashed && !item.active && !item.task.completed && solver;
            });
            
            return (
                <PerfectScrollbar
                    className=''
                    options={{ wheelPropagation: false }}
                    containerRef={ref => {
                        if (ref) {
                            ref._getBoundingClientRect = ref.getBoundingClientRect

                            ref.getBoundingClientRect = () => {
                            const original = ref._getBoundingClientRect()

                            return { ...original, height: Math.floor(original.height) }
                            }
                        }
                    }}
                >
                    {tasksToRender.length > 0 &&    
                    tasksToRender.map(item => {
                        return renderTask(item)
                    })
                    }
                </PerfectScrollbar>
            );
        }

        return (
            <Fragment>
                <div className='todo-modal-list'>
                    {loading && <LinearIndeterminate />}

                    {!loading && renderTasks()}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.login.user,
        store: state.todoApp,
        activity: state.activity.action
    }
}

export default connect(mapStateToProps, { 
    getTasks,
    loading, 
    sorting,
    startWork,
    endWork,
    updateTasks,
    //untrash,
}) (Tasks)